import toPromise from 'lib/to-promise';
import EF from 'ef/ef';
import { LocalStorageService } from 'services/data-handler-services/web-storage-service';
import utils from 'lib/utils';

const ResourceService = function () {
  this.getResources = function (resourceType, resourceSubType) {
    // note resourceSubType is actually the slug
    EF.resources.forEach(resource => {
      if (!resource.get('signed')) {
        const id = resource.get('id');
        const policyId = parseInt(id.substr(id.indexOf('-') + 1));
        const signed = LocalStorageService.getItem(`${policyId}---signed`);
        resource.set('signed', signed ? true : false);
      }
    });
    return toPromise(EF.resources.byType(resourceType, resourceSubType));
  };

  this.loadResources = function () {
    return toPromise(EF.resources.fetch());
  };

  this.save = function (resourceItem) {
    LocalStorageService.setItem(`${resourceItem.id}---signed`, true);
    return resourceItem
      .save()
      .then(response =>
        utils.httpErrorHandler(response, EF.resources.checkIfAllResourcesSigned(resourceItem?.get('sub_type')))
      );
  };
};

export default new ResourceService();
